import { AddressInterface } from 'common/address.interface';
import {
  SellingPointInterface,
  SellingPointPayment,
  SellingPointTransaction,
} from 'store/ducks/sellingPoints/types';

/*
 * Action Types
 */
export enum SellingTerminalsTypes {
  LIST_SELLING_TERMINALS_REQUEST = '@sellingTerminals/LIST_SELLING_TERMINALS_REQUEST',
  LIST_SELLING_TERMINALS_SUCCESS = '@sellingTerminals/LIST_SELLING_TERMINALS_SUCCESS',
  LIST_SELLING_TERMINALS_FAILURE = '@sellingTerminals/LIST_SELLING_TERMINALS_FAILURE',

  GET_SELLING_TERMINAL_REQUEST = '@sellingTerminals/GET_SELLING_TERMINAL_REQUEST',
  GET_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/GET_SELLING_TERMINAL_SUCCESS',
  GET_SELLING_TERMINAL_FAILURE = '@sellingTerminals/GET_SELLING_TERMINAL_FAILURE',

  GET_DAILY_SELLING_TERMINAL_REQUEST = '@sellingTerminals/GET_DAILY_SELLING_TERMINAL_REQUEST',
  GET_DAILY_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/GET_DAILY_SELLING_TERMINAL_SUCCESS',
  GET_DAILY_SELLING_TERMINAL_FAILURE = '@sellingTerminals/GET_DAILY_SELLING_TERMINAL_FAILURE',

  FILTER_SELLING_TERMINALS_REQUEST = '@sellingTerminals/FILTER_SELLING_TERMINALS_REQUEST',
  FILTER_SELLING_TERMINALS_SUCCESS = '@sellingTerminals/FILTER_SELLING_TERMINALS_SUCCESS',
  FILTER_SELLING_TERMINALS_FAILURE = '@sellingTerminals/FILTER_SELLING_TERMINALS_FAILURE',

  CREATE_SELLING_TERMINAL_REQUEST = '@sellingTerminals/CREATE_SELLING_TERMINAL_REQUEST',
  CREATE_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/CREATE_SELLING_TERMINAL_SUCCESS',
  CREATE_SELLING_TERMINAL_FAILURE = '@sellingTerminals/CREATE_SELLING_TERMINAL_FAILURE',

  UPDATE_SELLING_TERMINAL_REQUEST = '@sellingTerminals/UPDATE_SELLING_TERMINAL_REQUEST',
  UPDATE_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/UPDATE_SELLING_TERMINAL_SUCCESS',
  UPDATE_SELLING_TERMINAL_FAILURE = '@sellingTerminals/UPDATE_SELLING_TERMINAL_FAILURE',

  DELETE_SELLING_TERMINAL_REQUEST = '@sellingTerminals/DELETE_SELLING_TERMINAL_REQUEST',
  DELETE_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/DELETE_SELLING_TERMINAL_SUCCESS',
  DELETE_SELLING_TERMINAL_FAILURE = '@sellingTerminals/DELETE_SELLING_TERMINAL_FAILURE',

  ADD_PAYMENT_SELLING_TERMINAL_REQUEST = '@sellingTerminals/ADD_PAYMENT_SELLING_TERMINAL_REQUEST',
  ADD_PAYMENT_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/ADD_PAYMENT_SELLING_TERMINAL_SUCCESS',
  ADD_PAYMENT_SELLING_TERMINAL_FAILURE = '@sellingTerminals/ADD_PAYMENT_SELLING_TERMINAL_FAILURE',

  ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_REQUEST = '@sellingTerminals/ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_REQUEST',
  ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_SUCCESS = '@sellingTerminals/ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_SUCCESS',
  ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_FAILURE = '@sellingTerminals/ADD_PRE_PAID_PAYMENT_SELLING_TERMINAL_FAILURE',

  LIST_SELLING_TERMINAL_WALLET_HISTORIES_REQUEST = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_HISTORIES_REQUEST',
  LIST_SELLING_TERMINAL_WALLET_HISTORIES_SUCCESS = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_HISTORIES_SUCCESS',
  LIST_SELLING_TERMINAL_WALLET_HISTORIES_FAILURE = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_HISTORIES_FAILURE',

  LIST_SELLING_TERMINAL_WALLET_BALANCE_REQUEST = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_BALANCE_REQUEST',
  LIST_SELLING_TERMINAL_WALLET_BALANCE_SUCCESS = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_BALANCE_SUCCESS',
  LIST_SELLING_TERMINAL_WALLET_BALANCE_FAILURE = '@sellingTerminals/LIST_SELLING_TERMINAL_WALLET_BALANCE_FAILURE',

  CHANGE_SELLING_TERMINAL_STATUS_REQUEST = '@sellingTerminals/CHANGE_SELLING_TERMINAL_STATUS_REQUEST',
  CHANGE_SELLING_TERMINAL_STATUS_SUCCESS = '@sellingTerminals/CHANGE_SELLING_TERMINAL_STATUS_SUCCESS',
  CHANGE_SELLING_TERMINAL_STATUS_FAILURE = '@sellingTerminals/CHANGE_SELLING_TERMINAL_STATUS_FAILURE',

  LIST_PAYMENTS_REQUEST = '@sellingTerminals/LIST_PAYMENTS_REQUEST',
  LIST_PAYMENTS_SUCCESS = '@sellingTerminals/LIST_PAYMENTS_SUCCESS',
  LIST_PAYMENTS_FAILURE = '@sellingTerminals/LIST_PAYMENTS_FAILURE',

  LIST_TRANSACTIONS_REQUEST = '@sellingTerminals/LIST_TRANSACTIONS_REQUEST',
  LIST_TRANSACTIONS_SUCCESS = '@sellingTerminals/LIST_TRANSACTIONS_SUCCESS',
  LIST_TRANSACTIONS_FAILURE = '@sellingTerminals/LIST_TRANSACTIONS_FAILURE',

  LIST_TRANSACTIONS_RESUME_REQUEST = '@sellingTerminals/LIST_TRANSACTIONS_RESUME_REQUEST',
  LIST_TRANSACTIONS_RESUME_SUCCESS = '@sellingTerminals/LIST_TRANSACTIONS_RESUME_SUCCESS',
  LIST_TRANSACTIONS_RESUME_FAILURE = '@sellingTerminals/LIST_TRANSACTIONS_RESUME_FAILURE',

  GET_SELLING_TERMINALS_RESUME_REQUEST = '@sellingTerminals/GET_SELLING_TERMINALS_RESUME_REQUEST',
  GET_SELLING_TERMINALS_RESUME_SUCCESS = '@sellingTerminals/GET_SELLING_TERMINALS_RESUME_SUCCESS',
  GET_SELLING_TERMINALS_RESUME_FAILURE = '@sellingTerminals/GET_SELLING_TERMINALS_RESUME_FAILURE',

  GET_SELLING_REPORTS_RESUME_REQUEST = '@sellingTerminals/GET_SELLING_REPORTS_RESUME_REQUEST',
  GET_SELLING_REPORTS_RESUME_SUCCESS = '@sellingTerminals/GET_SELLING_REPORTS_RESUME_SUCCESS',
  GET_SELLING_REPORTS_RESUME_FAILURE = '@sellingTerminals/GET_SELLING_REPORTS_RESUME_FAILURE',

  SELLING_TERMINALS_PAY_BOLETO_REQUEST = '@sellingTerminals/SELLING_TERMINALS_PAY_BOLETO_REQUEST',
  SELLING_TERMINALS_PAY_BOLETO_SUCCESS = '@sellingTerminals/SELLING_TERMINALS_PAY_BOLETO_SUCCESS',
  SELLING_TERMINALS_PAY_BOLETO_FAILURE = '@sellingTerminals/SELLING_TERMINALS_PAY_BOLETO_FAILURE',

  LIST_SELLING_TERMINAL_CASHIER_REQUEST = '@sellingTerminals/LIST_SELLING_TERMINAL_CASHIER_REQUEST',
  LIST_SELLING_TERMINAL_CASHIER_SUCCESS = '@sellingTerminals/LIST_SELLING_TERMINAL_CASHIER_SUCCESS',
  LIST_SELLING_TERMINAL_CASHIER_FAILURE = '@sellingTerminals/LIST_SELLING_TERMINAL_CASHIER_FAILURE',

  SET_SELECTED_RECEIVING_TYPE = '@sellingTerminals/SET_SELECTED_RECEIVING_TYPE',

  LIST_SELLING_SHIFT_REQUEST = '@sellingShifts/LIST_SELLING_SHIFT_REQUEST',
  LIST_SELLING_SHIFT_SUCCESS = '@sellingShifts/LIST_SELLING_SHIFT_SUCCESS',
  LIST_SELLING_SHIFT_FAILURE = '@sellingShifts/LIST_SELLING_SHIFT_FAILURE',

  LIST_TICKET_COUNT_REQUEST = '@sellingShifts/LIST_TICKET_COUNT_REQUEST',
  LIST_TICKET_COUNT_SUCCESS = '@sellingShifts/LIST_TICKET_COUNT_SUCCESS',
  LIST_TICKET_COUNT_FAILURE = '@sellingShifts/LIST_TICKET_COUNT_FAILURE',

  CREATE_TICKET_COUNT_REQUEST = '@sellingShifts/CREATE_TICKET_COUNT_REQUEST',
  CREATE_TICKET_COUNT_SUCCESS = '@sellingShifts/CREATE_TICKET_COUNT_SUCCESS',
  CREATE_TICKET_COUNT_FAILURE = '@sellingShifts/CREATE_TICKET_COUNT_FAILURE',

  UPDATE_TICKET_COUNT_REQUEST = '@sellingShifts/UPDATE_TICKET_COUNT_REQUEST',
  UPDATE_TICKET_COUNT_SUCCESS = '@sellingShifts/UPDATE_TICKET_COUNT_SUCCESS',
  UPDATE_TICKET_COUNT_FAILURE = '@sellingShifts/UPDATE_TICKET_COUNT_FAILURE',

  DELETE_TICKET_COUNT_REQUEST = '@sellingShifts/DELETE_TICKET_COUNT_REQUEST',
  DELETE_TICKET_COUNT_SUCCESS = '@sellingShifts/DELETE_TICKET_COUNT_SUCCESS',
  DELETE_TICKET_COUNT_FAILURE = '@sellingShifts/DELETE_TICKET_COUNT_FAILURE',

  LIST_SHIFT_SCHEDULE_REQUEST = '@sellingShifts/LIST_SHIFT_SCHEDULE_REQUEST',
  LIST_SHIFT_SCHEDULE_SUCCESS = '@sellingShifts/LIST_SHIFT_SCHEDULE_SUCCESS',
  LIST_SHIFT_SCHEDULE_FAILURE = '@sellingShifts/LIST_SHIFT_SCHEDULE_FAILURE',

  CREATE_SHIFT_SCHEDULE_REQUEST = '@sellingShifts/CREATE_SHIFT_SCHEDULE_REQUEST',
  CREATE_SHIFT_SCHEDULE_SUCCESS = '@sellingShifts/CREATE_SHIFT_SCHEDULE_SUCCESS',
  CREATE_SHIFT_SCHEDULE_FAILURE = '@sellingShifts/CREATE_SHIFT_SCHEDULE_FAILURE',

  UPDATE_SHIFT_SCHEDULE_REQUEST = '@sellingShifts/UPDATE_SHIFT_SCHEDULE_REQUEST',
  UPDATE_SHIFT_SCHEDULE_SUCCESS = '@sellingShifts/UPDATE_SHIFT_SCHEDULE_SUCCESS',
  UPDATE_SHIFT_SCHEDULE_FAILURE = '@sellingShifts/UPDATE_SHIFT_SCHEDULE_FAILURE',

  DELETE_SHIFT_SCHEDULE_REQUEST = '@sellingShifts/DELETE_SHIFT_SCHEDULE_REQUEST',
  DELETE_SHIFT_SCHEDULE_SUCCESS = '@sellingShifts/DELETE_SHIFT_SCHEDULE_SUCCESS',
  DELETE_SHIFT_SCHEDULE_FAILURE = '@sellingShifts/DELETE_SHIFT_SCHEDULE_FAILURE',

  SHIFT_SCHEDULE_RUN_REQUEST = '@sellingShifts/SHIFT_SCHEDULE_RUN_REQUEST',
  SHIFT_SCHEDULE_RUN_SUCCESS = '@sellingShifts/SHIFT_SCHEDULE_RUN_SUCCESS',
  SHIFT_SCHEDULE_RUN_FAILURE = '@sellingShifts/SHIFT_SCHEDULE_RUN_FAILURE',
}

/*
 * Data types
 */
export interface SellingTerminalAddressInterface extends AddressInterface {
  id: string;
  latitude: number;
  longitude: number;
  createdAt: string;
  updatedAt: string;
  sellingTerminalId: string;
  SellingTerminalAddress: {
    id: string;
    createdAt: string;
    updatedAt: string;
    sellingTerminalId: string;
    addressId: string;
  };
}

export interface SellingTerminalPaymentInterface {
  id: string;
  amount: number;
  description: string;
  supervisorId: string;
  createdAt: string;
  updatedAt: string;
  sellingTerminalId: string;
  TransportSupervisor: {
    id: string;
    name: string;
    email: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface SellingTerminalsResumeInterface {
  totalPending: number;
  totalCollected: number;
  totalPaid: number;
  totalTicketCount: number;
  totalPurchaseCount: number;
}

export interface ResumeInterface {
  transactionValue: number;
  transactionCount: number;
  purchaseTransactionValue: number;
  purchaseTransactionCount: number;
  ticketTransactionValue: number;
  ticketTransactionCount: number;
  pointPaymentValue: number;
  pointPaymentCount: number;
  terminalPaymentValue: number;
  terminalPaymentCount: number;
  lastTerminalPayments: Array<SellingPointPayment>;
}

export interface SellingTerminalInterface {
  id: string;
  fee: number;
  status: number;
  type: number;
  allowedAmount: number;
  name: string;
  document: string;
  email: string;
  phone: string;
  startPeriod: string;
  endPeriod: string;
  resume?: ResumeInterface;
  SellingPoints?: Array<SellingPointInterface>;
  SellingTerminalPayments?: Array<SellingTerminalPaymentInterface>;
  Addresses?: Array<SellingTerminalAddressInterface>;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
  pointTransactionMethods?: string[];
  pointTransactionRegister?: Array<{
    [key: string]: string | null;
  }>;
  hasChange?: boolean;
  TransportOperators?: Array<{
    id: string;
    name: string;
    shortName: string;
    cnpj: string;
    photoUrl: string;
    createdAt: string;
    updatedAt: string;
    SellingTerminalTransportOperator: {
      id: string;
      status: number;
      fee: number;
      allowedAmount: number;
      createdAt: string;
      updatedAt: string;
      sellingTerminalId: string;
      transportOperatorId: string;
      pointTransactionMethods?: string[];
      terminalOperationMethods?: string[];
      operationMethods?: string[];
      pointTransactionRegister?: Array<{
        [key: string]: 'ONBOARD' | 'AGR' | null | 'NOT_VALIDATE';
      }>;
      terminalPaymentMethods?: string[];
      pointLineSectionIds?: string[] | null;
      blockDays: number;
      billingEntries: string[] | null;
      billingFrequency: number | null;
      billingType: string | null;
      sangria?: boolean;
      cashierOpeningAndClosing?: boolean;
      sangriaWithValue?: number;
      blockId?: string;
      allowMultiplePaymentMethods?: boolean;
      allowPrePaid?: boolean;
      autoOpen?: boolean;
      autoOpenTime?: Date | null;
      autoClose?: boolean;
      autoCloseTime?: Date | null;
      creditsAmount?: number;
      singleTicketProfiles: string[];
      hasTicketRegister?: boolean;
      maxTickets?: number | null;
    };
  }>;
  pointPaymentMethods?: string[];
  terminalPaymentMethods?: string[];
  pointLineSectionIds?: string[] | null;
  blockDays?: number;
  billingEntries?: string[] | null;
  billingFrequency?: number | null;
  billingType?: string | null;
  shiftOpenSupervisor?: boolean;
  shiftCloseSupervisor?: boolean;
  shiftCashSupervisor?: boolean;
  ticketPrintSupervisor?: boolean;
  sellCancelSupervisor?: boolean;
  withdrawSupervisor?: boolean;
  cancelSupervisor?: boolean;
}

export interface SellingTerminalResumeInterface {
  sellingTerminalId: string;
  transactioned: number;
  paid: number;
  owned: number;
  transactionIds: string[];
  date: string;
}

export interface SellingTerminalsDailyReportInterface {
  usedDate: string | null;
  transactioned: number;
  paid: number;
  owned: number;
}

export interface SellingShiftInterface {
  id: string;
  status: number;
  startedAt: string;
  closedAt: string;
  createdAt: string;
  updatedAt: string;
  sellingPointId: string;
  transportOperatorId: string;
  SellingPoint?: SellingPointInterface;
  SellingPointTransactions?: SellingPointTransaction[];
  SellingPointPayments?: SellingPointPayment[];
  terminalPaymentMethods?: string[];
}
export interface sellingTerminalCashierInterface {
  sellingPointName: string;
  totalValue: number;
}

export interface SellingTerminalWalletHistoryInterface {
  id: string;
  operation: number;
  priorValue: number;
  currentValue: number;
  transactionValue: number;
  transactionDatetime: string;
  createdAt: string;
  updatedAt: string;
  sellingTerminalId: string;
  sellingPointTransactionId: string | null;
  sellingTerminalChargeRequestId: string | null;
  transportOperatorId: string;
  SellingTerminalChargeRequest?: any;
}

export interface SellingTerminalWalletBalanceInterface {
  terminalId: string;
  terminalName: string;
  credit: number | null;
  debit: number | null;
  balance: number | null;
}

export interface TicketCountListInterface {
  id: string;
  name: string;
  sellingTerminalId: string;
}

export interface SellingPointShift {
  id: string;
  startedAt: string;
  closedAt: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  sellingPointId: string;
  status: number;
  sellingTerminalPlaceId: string;
  openSupervisorId: string | null;
  closeSupervisorId: string | null;
}
export interface ShiftScheduleListInterface {
  id: string;
  startAt: string;
  closeAt: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  sellingPointId: string;
  sellingTerminalPlaceId: string;
  sellingPointShiftId: string;
  amount: number;
  sellingTerminalId: string;
  SellingPointShift: SellingPointShift | null;
}

/*
 * State type
 */
export interface SellingTerminalsState {
  readonly sellingTerminalsList: SellingTerminalInterface[];
  readonly sellingTerminalData: SellingTerminalInterface;
  readonly sellingTerminalsResume: SellingTerminalsResumeInterface;
  readonly sellingTerminalsResumeList: SellingTerminalResumeInterface[];
  readonly sellingReportsResume: SellingTerminalsResumeInterface;
  readonly sellingTerminalsDailyReports: SellingTerminalsDailyReportInterface[];
  readonly selectedReceivingType?: number;
  readonly paymentsList: any[];
  readonly transactionsList: any[];
  readonly sellingTerminalWalletHistories: SellingTerminalWalletHistoryInterface[];
  readonly sellingTerminalWalletBalances: SellingTerminalWalletBalanceInterface[];
  readonly sellingShiftList: SellingShiftInterface[];
  readonly sellingTerminalCashierList: sellingTerminalCashierInterface[];
  readonly ticketCountList: TicketCountListInterface[];
  readonly shiftScheduleList: ShiftScheduleListInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
